export default {
    name: 'notification',
    notifications: 'notifications',
};
